module.exports = __webpack_public_path__ + "img/feature_bottom_separate.4ce6fbc5.svg";